import { TDryRunBody } from '@src/modules'

import { request } from './config'

export const runTierMonthly = (body: TDryRunBody, token: string) =>
  request({ url: 'dealer-tier/admin/run-monthly', method: 'POST', data: body }, { token })

export const runTierNightlyDelta = (body: TDryRunBody, token: string) =>
  request({ url: 'dealer-tier/admin/run-nightly-delta', method: 'POST', data: body }, { token })

export const peekTier = (dealerId: number, token: string) =>
  request({ url: `dealer-tier/admin/peek/${dealerId}`, method: 'GET' }, { token })

export const refreshRanking = (token: string) =>
  request({ url: 'ranking/admin/refresh', method: 'POST' }, { token })

export const runDailyRank = (token: string) =>
  request({ url: 'ranking/admin/run-daily-rank', method: 'POST' }, { token })

export const runWeeklyRank = (token: string) =>
  request({ url: 'ranking/admin/run-weekly-rank', method: 'POST' }, { token })
